// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.EGynm8X_9qwaIp {
  margin: var(--ds-space-0, 0) var(--ds-space-050, 4px);
  color: var(--ds-text-subtlest, #626f86);
}
`, ""]);
// Exports
export var remainingCount = `EGynm8X_9qwaIp`;
export default ___CSS_LOADER_EXPORT___;
